import { render } from "./EncountersPage.vue?vue&type=template&id=3bf404a7&scoped=true"
import script from "./EncountersPage.vue?vue&type=script&lang=js"
export * from "./EncountersPage.vue?vue&type=script&lang=js"

import "./EncountersPage.vue?vue&type=style&index=0&id=3bf404a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf404a7"]])

export default __exports__